import { getFromLocalStorage } from 'utilities/localStorage'

export const FEATURES = {
    LOGIN: 'login',
    SUBSCRIPTION: 'subscription',
    DYNAMIC_DEADLINE: 'dynamicDeadline',
    CVC: 'cvc',
    VIPPS: 'vipps',
    GA4: 'ga4',
}

export function isFeatureEnabled(features, feature) {
    return features.enabled[feature]
}

export function getFeaturesEnabled() {
    const urlFeatures = getUrlFeatures()
    const localFeatures = getLocalStorageFeatures()
    const envFeatures = getEnvFeatures()
    return envFeatures.concat(localFeatures, urlFeatures)
}

export function getEnvFeatures() {
    return process.env.FEATURES_ENABLED ? process.env.FEATURES_ENABLED.split(',') : []
}

export function getUrlFeatures() {
    const urlParams = new URLSearchParams(window.location.search)
    const features = urlParams.get('features')
    return features ? features.split(',') : []
}

export function getLocalStorageFeatures() {
    return getFromLocalStorage('features') ? getFromLocalStorage('features').split(',') : []
}
